export function useCrudHouseholdMutation(householdId, useMutation) {  
  const [performMutation, mutationResult] = useMutation();
  return () => {
    return [(params) => performMutation({ householdId, ...params }), mutationResult];
  };
}
